import React, { createContext, useContext } from 'react'
import { GeckoComponentCoords, GeckoInspection, GeckoReport } from 'types'

export interface FormState {
  fileName: string
  fileCaption: string
}

export interface EditingState {
  fileName: boolean
  fileCaption: boolean
  coordinates: boolean
}

interface ImagePreviewerContextType {
  imageUrl: string
  imageThumbnail: GeckoReport
  componentID: string | undefined
  inspectionID: string | undefined
  editingState: EditingState
  setEditingState: React.Dispatch<React.SetStateAction<EditingState>>
  formState: FormState
  setFormState: React.Dispatch<React.SetStateAction<FormState>>
  handleDeleteClick: (e: React.MouseEvent) => void
  selectedCoords: GeckoComponentCoords | undefined
  inspection: GeckoInspection | undefined
  handleSave: () => Promise<void>
  handleClose: () => void
}

const ImagePreviewerContext = createContext<
  ImagePreviewerContextType | undefined
>(undefined)

export const useImagePreviewerContext = () => {
  const context = useContext(ImagePreviewerContext)
  if (!context) {
    throw new Error(
      'useImagePreviewerContext must be used within an ImagePreviewerProvider'
    )
  }
  return context
}

export const ImagePreviewerProvider: React.FC<
  ImagePreviewerContextType & { children: React.ReactNode }
> = ({ children, ...values }) => {
  return (
    <ImagePreviewerContext.Provider value={values}>
      {children}
    </ImagePreviewerContext.Provider>
  )
}
